export default __webpack_public_path__ + "static/media/necroticempowerment.9a5734e5.png";